// extracted by mini-css-extract-plugin
export default {"orderListContainer":"OrderList_orderListContainer__G7tY6","header":"OrderList_header__6inB5"};